import { render, staticRenderFns } from "./referenceGallery.vue?vue&type=template&id=45b5870c&scoped=true&"
import script from "./referenceGallery.vue?vue&type=script&lang=js&"
export * from "./referenceGallery.vue?vue&type=script&lang=js&"
import style0 from "./referenceGallery.vue?vue&type=style&index=0&id=45b5870c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b5870c",
  null
  
)

export default component.exports